import { Card, CardHeader } from "./card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./tabs";

export interface Tab {
  value: string;
  label: string;
  content?: React.ReactNode;
}

export interface TabbedContainerProps {
  children?: React.ReactNode;
  defaultValue?: string;
  tabs: Tab[];
  className?: string;
  showCard?: boolean;
  tabsClassName?: string;
  contentClassName?: string;
  onValueChange?: (newVal: string) => void;
}

export function TabbedContainer({
  children,
  defaultValue,
  tabs,
  className = "",
  showCard = true,
  tabsClassName = "",
  contentClassName = "mt-0",
  onValueChange,
}: TabbedContainerProps) {
  const content = (
    <Tabs defaultValue={defaultValue || tabs[0]?.value} onValueChange={onValueChange} className="w-full">
      <div className="flex-shrink-0">
        <TabsList className={`mb-1 mt-0 ${tabsClassName}`}>
          {tabs.map((tab) => (
            <TabsTrigger key={tab.value} value={tab.value}>
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </div>

      {tabs.map((tab) => (
        <TabsContent key={tab.value} value={tab.value} className={`w-full ${contentClassName}`}>
          {tab.content}
        </TabsContent>
      ))}

      {children}
    </Tabs>
  );

  if (showCard) {
    return (
      <Card className={`p-6 w-full ${className}`}>
        <CardHeader className="space-y-0 pb-0 px-0">{content}</CardHeader>
      </Card>
    );
  }

  return content;
}
